import Vue from 'vue'
import App from './App.vue'
import store from './store';
import Router from 'vue-router'

Vue.use(Router);

var urlParams = new URLSearchParams(window.location.search)

const router = new Router({
    mode: 'history',
    routes: [
        // { path: '/:id/:src',  component: App },
        // { path: '**', component: App }
    ]
});

router.beforeEach((to, from, next) => {
    if (!from.query.src && !to.query.src) {
      next({path: to.path, query: {overlay: urlParams.get('overlay'), src:urlParams.get('src')}})
    }
    
    next()
})

Vue.config.productionTip = false

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')
